import { render, staticRenderFns } from "./WorkloadDetailEndpoints.vue?vue&type=template&id=fdb64178&scoped=true&"
import script from "./WorkloadDetailEndpoints.vue?vue&type=script&lang=js&"
export * from "./WorkloadDetailEndpoints.vue?vue&type=script&lang=js&"
import style0 from "./WorkloadDetailEndpoints.vue?vue&type=style&index=0&id=fdb64178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb64178",
  null
  
)

export default component.exports